if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (!this.form) return;

        this.variantIdInput.disabled = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton
          ? this.submitButton.querySelector('span')
          : null;

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.submitButton) return;

        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        config.body = formData;

        try {
          const response = await fetch(
            `${routes.cart_add_url}`,
            config
          );

          const result = await response.json();

          if (result.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: result.errors || result.description,
              message: result.message,
            });

            this.handleErrorMessage(result.description);

            const soldOutMessage =
              this.submitButton.querySelector('.sold-out-message');

            if (soldOutMessage) {
              this.submitButton.setAttribute(
                'aria-disabled',
                true
              );

              if (this.submitButtonText) {
                this.submitButtonText.classList.add('hidden');
              }

              soldOutMessage.classList.remove('hidden');
            }

            this.error = true;

            return;
          }

          this.error = false;

          /*
           * Informe les autres composants Shopify
           * qu'un produit vient d'être ajouté.
           */
          try {
            await publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: result,
            });
          } catch (error) {
            console.warn(
              '[BDM] Publication cartUpdate impossible :',
              error
            );
          }

          /*
           * Si on se trouve dans le Quick Add Shopify,
           * on ferme d'abord la modale produit.
           */
          const quickAddModal = this.closest(
            'quick-add-modal'
          );

          if (quickAddModal) {
            quickAddModal.hide(true);

            document.body.addEventListener(
              'modalClosed',
              async () => {
                await this.openBdmCart();
              },
              { once: true }
            );
          } else {
            await this.openBdmCart();
          }
        } catch (error) {
          console.error(
            '[BDM] Erreur lors de l’ajout au panier :',
            error
          );

          this.handleErrorMessage(
            'Une erreur est survenue. Merci de réessayer.'
          );
        } finally {
          this.submitButton.classList.remove('loading');

          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
          }

          if (spinner) {
            spinner.classList.add('hidden');
          }

          if (
            typeof CartPerformance !== 'undefined' &&
            CartPerformance.measureFromEvent
          ) {
            CartPerformance.measureFromEvent(
              'add:user-action',
              evt
            );
          }
        }
      }

      async openBdmCart() {
        /*
         * =========================================================
         * PANIER GLOBAL BAUME DU MONT
         * =========================================================
         *
         * On ne demande plus à Dawn d'afficher <cart-drawer>.
         * Tous les ajouts passent maintenant par BdmGlobalCart.
         */

        if (window.BdmGlobalCart) {
          try {
            if (
              typeof window.BdmGlobalCart.refresh ===
              'function'
            ) {
              await window.BdmGlobalCart.refresh();
            }

            if (
              typeof window.BdmGlobalCart.open ===
              'function'
            ) {
              window.BdmGlobalCart.open();
            }

            return;
          } catch (error) {
            console.error(
              '[BDM] Impossible d’ouvrir le panier global :',
              error
            );
          }
        }

        /*
         * Sécurité :
         * si jamais le panier BDM n'est pas chargé sur une page,
         * on redirige simplement vers /cart plutôt que de casser
         * l'ajout au panier.
         */

        if (window.routes && window.routes.cart_url) {
          window.location.href = window.routes.cart_url;
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (text && this.submitButtonText) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');

          if (this.submitButtonText) {
            this.submitButtonText.textContent =
              window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}